import axios from '@axios';
import HelperService from '@/services/HelperService';
const helperService = new HelperService();
const baseUrl = 'api/v1/restricted-booking-dates';

export default {
  getRestrictedDates(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${baseUrl}${queryString}`);
  },
  addRestrictedDate(dto) {
    return axios.post(`${baseUrl}/create-for-prison`, dto);
  },
  deleteDate(dateId) {
    return axios.delete(`${baseUrl}/delete/${dateId}`);
  },
  updateDate(dateId, dto) {
    return axios.post(`${baseUrl}/update/${dateId}`, dto);
  },
  getDate(dateId) {
    return axios.get(`${baseUrl}/getSingle/${dateId}`);
  },
  getFutureRestrictedDates() {
    return axios.get(`${baseUrl}/future-for-prison/`);
  },
};
